import { render, staticRenderFns } from "./ContentFeedEventTicket.vue?vue&type=template&id=3b242312&scoped=true&"
import script from "./ContentFeedEventTicket.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedEventTicket.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedEventTicket.vue?vue&type=style&index=0&id=3b242312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b242312",
  null
  
)

export default component.exports